import './App.css';
import SnackBarProvider from 'components/SnackBarProvider';
import { GFO_TOKEN, getBaseURL } from 'constants/index';

import ErrorFallback from 'pages/ErrorFallback';
import React, { useEffect } from 'react';
import { Router, useHistory } from 'react-router-dom';
import Routes from 'Routes';
import { createCookie, getQueryStringValue } from 'utils';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ErrorBoundary } from '@sentry/react';
import OverlayProvider from 'components/OverlayProvider';
import CartProvider from 'components/CartProvider';
import AddressProvider from 'components/AddressProvider';
import { SessionJsonStorage } from 'utils/storage';
import JSONLD from 'components/JSONLD';
import { isApp } from 'utils/app';
import { historyData } from 'utils/history';
import AuthProvider from 'components/AuthProvider';
import RedirectProvider from 'components/RedirectProvider';
import CateringProvider from 'components/CateringProvider';
import AppThemeProvider from 'components/AppThemeProvider';
import AlertProvider from 'components/AlertProvider';
import AppProvider from 'components/AppProvider';
import MetaTags from './MetaTag';
import useStructuredData from './useStructuredData';
import AppUpdateOverlay from './AppUpdateOverlay';

function App() {
  const history = useHistory();
  const structuredData = useStructuredData();
  const baseURL = getBaseURL();

  useEffect(() => {
    const clear = history.listen((location, action) => {
      let { pathStack = [] } = historyData.get();
      if (action === 'PUSH') {
        pathStack = [...pathStack, { action, ...location }];
      }
      if (action === 'POP' && pathStack.length > 0) {
        pathStack = [...pathStack.slice(-1)];
      }
      pathStack = [...pathStack.slice(-1), { action, ...location }];
      historyData.update({ lastAction: action, pathStack });
    });
    return clear;
  }, [history]);

  useEffect(() => {
    const GFOToken = getQueryStringValue(GFO_TOKEN);
    if (GFOToken) {
      createCookie({
        name: GFO_TOKEN,
        value: GFOToken,
        expireTimeInMinutes: 30,
      });
    }
  }, []);

  useEffect(() => {
    const baseURL = getQueryStringValue('baseURL');
    if (baseURL) {
      SessionJsonStorage.set({
        key: 'baseURL',
        value: baseURL,
      });
      window.location.replace(window.location.pathname);
    }
  }, []);

  return (
    <AppProvider>
      <AppThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <RedirectProvider>
            <AuthProvider>
              <AlertProvider>
                <OverlayProvider>
                  <SnackBarProvider>
                    <AddressProvider>
                      <CartProvider>
                        <CateringProvider>
                          <MetaTags />
                          {!isApp() && baseURL.customized && (
                            <div
                              style={{
                                background: 'crimson',
                                color: '#fff',
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                zIndex: 10000,
                                fontSize: 12,
                              }}
                            >
                              baseURL:
                              {' '}
                              {baseURL.url}
                            </div>
                          )}
                          <ErrorBoundary fallback={<ErrorFallback />}>
                            <AppUpdateOverlay />
                            <CartProvider.CartOverlay />
                            <Router history={history}>
                              <JSONLD data={structuredData} />
                              <Routes />
                            </Router>
                          </ErrorBoundary>
                        </CateringProvider>
                      </CartProvider>
                    </AddressProvider>
                  </SnackBarProvider>
                </OverlayProvider>
              </AlertProvider>
            </AuthProvider>
          </RedirectProvider>
        </LocalizationProvider>
      </AppThemeProvider>
    </AppProvider>
  );
}

export default App;
